export enum EAttachmentKind {
    DOCX = 'docx',
    PDF = 'pdf',
    TEMPLATE = 'template',
    TICKET = 'ticket',
    PROMISSORY_NOTE = 'promissory_note'
}